import { UserForm } from "../../../components/users/UserForm";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useEditUser } from "@/hooks/users/useEditUser";
import { useUsers } from "@/hooks/users/useUsers";
import LoaderComponent from "@/components/common/LoaderComponent";

const EditUser = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const { user, scheduleConfig, loading, submitting, updateUser } = useEditUser(id || '');
  const { refetch } = useUsers();

  const handleSubmit = async (data: any) => {
    const success = await updateUser(data);
    if (success) {
      // Refetch users to update the table
      refetch();
      // Navigate back to users list after successful update, preserving query params
      setTimeout(() => {
        const searchParams = new URLSearchParams(location.search);
        navigate(`/admin/users?${searchParams.toString()}`);
      }, 1000);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <LoaderComponent size="lg" />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="rounded-md border border-destructive/50 bg-destructive/10 p-4">
        <p className="text-sm text-destructive">User not found</p>
      </div>
    );
  }

  // Map user data to form format
  const initialData = {
    firstname: user.user_name?.split(' ')[0] || '',
    lastname: user.user_name?.split(' ').slice(1).join(' ') || '',
    email: user.email || '',
    phonenumber: user.phone_number || '',
    password: '', // Password field will be empty for security
    usertype: user.user_type || '', // Use the actual user_type value from the API
  };

  return (
    <UserForm 
      title={`Edit User - ${user.user_name}`}
      initialData={initialData}
      initialScheduleConfig={scheduleConfig}
      onSubmit={handleSubmit}
      isLoading={submitting}
      returnPath={`/admin/users?${new URLSearchParams(location.search).toString()}`}
      isEditMode={true}
    />
  );
};

export default EditUser;
